import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { environment } from '../../environments/environment';

@Injectable()
export class MenuService {
    apiUrl: string;
    menu: any = {};
    constructor(public http: Http) {
        this.apiUrl = environment.baseUrl + '/cms/';
    }

    getMenu(language: string): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.menu[language]) {
                resolve(this.menu[language]);
            } else {
                this.http.get(this.apiUrl + 'menu/' + language).subscribe(data => {
                    let menu = data.json();
                    if (menu && menu[0]) {
                        menu = menu[0];
                    }
                    this.menu[language] = menu;
                    resolve(this.menu[language]);
                }, error => {
                    reject(error);
                });
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/providers/menu.service.ts